import { render } from "./InstructionPopup.vue?vue&type=template&id=2b0abd59&scoped=true"
import script from "./InstructionPopup.vue?vue&type=script&lang=js"
export * from "./InstructionPopup.vue?vue&type=script&lang=js"

import "./InstructionPopup.vue?vue&type=style&index=0&id=2b0abd59&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0abd59"]])

export default __exports__